import { render, staticRenderFns } from "./RegexEditor.vue?vue&type=template&id=722620a6&scoped=true"
import script from "./RegexEditor.vue?vue&type=script&lang=js"
export * from "./RegexEditor.vue?vue&type=script&lang=js"
import style0 from "./RegexEditor.vue?vue&type=style&index=0&id=722620a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722620a6",
  null
  
)

export default component.exports